module.exports = __webpack_public_path__ + "img/9AI-改3_04.e21cdad7.jpg";